import { Injectable } from '@angular/core';
import { Http} from '@angular/http';
import { environment } from '../../../../../environments/environment';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class ServiceServices {
    private apiUrl = `${environment.apiUrl}/api/v1`;
    private companyId = global['loginUser'].curCmpnId;

    constructor(private http: Http) {
        this.companyId = global['loginUser'].curCmpnId;
    };

    /**
     * service
     * service list 조회
     * Method : Get
     * API No : 4.01
     * url : /api/v1/{cmpnNo}/service
     * **/
    getServiceList(queryString?: any) {
        const queryParam = (queryString === undefined ? '' : queryString);
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/service${queryParam}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * service
     * service detail 조회
     * Method : Get
     * API No : 4.02
     * url : /api/v1/{cmpnNo}/service/{svcNo}
     * **/
    getServiceInfo(svcNo: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/service/${svcNo}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * service
     * service 수정
     * Method : Put
     * API No : 4.03
     * url : /api/v1/{cmpnNo}/service/{svcNo}
     * **/
    modifyService(svcNo: any, putData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/service/${svcNo}`;

        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * service
     * incident list 조회
     * Method : Get
     * API No : 4.05
     * url : /api/v1/{cmpnNo}/service/{svcNo}/incidents?
     * **/
    getIncidentList(svcNo, queryString?: any) {
        const queryParam = (queryString === undefined ? '' : queryString);
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/service/${svcNo}/incident${queryParam}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * service
     * integration list 조회
     * Method : Get
     * API No : 4.06
     * url : /api/v1/{cmpnNo}/service/{svcNo}/integrations?searchData={searchData}
     * **/
    getIntegrationList(svcNo, queryString?: any) {
        const queryParam = (queryString === undefined ? '' : queryString);
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/service/${svcNo}/integrations${queryParam}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * service
     * escalation list 조회
     * Method : Get
     * API No : 4.08
     * url : /api/v1/{cmpnNo}/service/${svcNo}/escalations
     * **/
    getEscalationList(svcNo: string, queryString?: any) {
        const queryParam = (queryString === undefined ? '' : queryString);
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/service/${svcNo}/escalations${queryParam}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * service
     * service member list 조회
     * Method : Get
     * API No : 4.09
     * url : /api/v1/{cmpnNo}/service/${svcNo}/member?searchData={searchData}
     * **/
    getSvcMemberList(svcNo: string, queryString?: any) {
        const queryParam = (queryString === undefined ? '' : queryString);
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/service/${svcNo}/member${queryParam}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * service
     * service member 매핑 해제
     * Method : delete
     * API No : 4.10
     * url : /api/v1/{cmpnNo}/service/{svcNo}/member/{userNo}
     * **/
    deleteSvcMember(svcNo: string, userNo: string) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/service/${svcNo}/member/${userNo}`;

        return this.http
            .delete(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * service
     * service member 등록
     * Mothod : Post
     * API No : 4.11
     * /api/v1/{cmpnNo}/service/{svcNo}/member
     * **/
    addMember(svcNo: string, postData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/service/${svcNo}/member`;

        return this.http
            .post(url, JSON.stringify(postData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * service
     * Maintenance schedule list 조회 (type=all 인 경우, 유지보수 이력 조회)
     * Method : Get
     * API No : 4.13
     * url : /api/v1/{cmpnNo}/service/${svcNo}/maintenance
     * **/
    getMtncPlanList(svcNo: string, queryString?: any) {
        const queryParam = (queryString === undefined ? '' : queryString);
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/service/${svcNo}/maintenance${queryParam}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * service
     * Maintenance schedule 등록
     * Mothod : Post
     * API No : 4.14
     * /api/v1/{cmpnNo}/service/{svcNo}/maintenance
     * **/
    addMtncPlan(svcNo: string, postData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/service/${svcNo}/maintenance`;

        return this.http
            .post(url, JSON.stringify(postData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * service
     * Maintenance schedule 상세
     * Method : Get
     * API No : 4.15
     * url : /api/v1/{cmpnNo}/service/${svcNo}/maintenance/{mtncPlanNo}
     * **/
    getMtncPlanInfo(svcNo: string, mtncPlanNo: string) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/service/${svcNo}/maintenance/${mtncPlanNo}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * service
     * Maintenance schedule 수정
     * Mothod : Put
     * API No : 4.16
     * url : /api/v1/{cmpnNo}/service/${svcNo}/maintenance/{mtncPlanNo}
     * **/
    modifyMtncPlan(svcNo: string, mtncPlanNo: string, putData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/service/${svcNo}/maintenance/${mtncPlanNo}`;

        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * service
     * Maintenance schedule 삭제
     * Method : delete
     * API No : 4.18
     * url : /api/v1/{cmpnNo}/service/${svcNo}/maintenance/{mtncPlanNo}
     * **/
    deleteMtncPlan(svcNo: string, mtncPlanNo: string) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/service/${svcNo}/maintenance/${mtncPlanNo}`;

        return this.http
            .delete(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * service
     * Maintenance schedule 시간 추가(End Time 변경)
     * Mothod : Put
     * API No : 4.19
     * url : /api/v1/{cmpnNo}/service/${svcNo}/maintenance/{mtncPlanNo}/time
     * **/
    modifyMtncPlanTime(svcNo: string, mtncPlanNo: string, putData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/service/${svcNo}/maintenance/${mtncPlanNo}/time`;

        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * service
     * Immediate Maintenance 등록
     * Mothod : Post
     * API No : 4.20
     * /api/v1/{cmpnNo}/service/{svcno}/maintenance/now
     * **/
    addMtncPlanNow(svcNo: string, postData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/service/${svcNo}/maintenance/now`;

        return this.http
            .post(url, JSON.stringify(postData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * service
     * service 등록
     * Mothod : Post
     * API No : 4.21
     * /api/v1/{cmpnNo}/service
     * **/
    addService(postData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/service`;

        return this.http
            .post(url, JSON.stringify(postData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * service
     * Service escalation rule 수정
     * Mothod : Put
     * API No : 6.06
     * /api/v1/{cmpnNo}/integration/service/{svcNo}/escalrule
     **/
    updateServiceEscalationRule(svcNo, putData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/service/${svcNo}/escalrule`;

        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    updateServiceSuppressionRule(svcNo, putData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/service/${svcNo}/alertrule/sprs`;

        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    updateServiceUrgencyRule(svcNo, putData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/service/${svcNo}/alertrule/urgc`;

        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    updateServiceDelayRule(svcNo, putData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/service/${svcNo}/alertrule/delay`;

        return this.http
        .put(url, JSON.stringify(putData))
        .toPromise()
        .then(res => res)
        .catch(this.handleError);
    }

    /**
     * service
     * 설치된 Extension 목록 조회
     * Mothod : Get
     * API No : 4.27
     * url : /api/v1/{cmpnNo}/service/{svcno}/extension/install
     * **/
    getExtensionList(svcNo: string, queryString: string) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/service/${svcNo}/extension/install?${queryString}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * service
     * Extension 수정
     * Mothod : Put
     * API No : 4.28
     * url : /api/v1/{cmpnNo}/service/{svcno}/extension/{extApplInstlNo}
     * **/
    modifyExtension(svcNo: string, extApplInstlNo: string, putData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/service/${svcNo}/extension/${extApplInstlNo}`;

        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * service
     * Extension 삭제
     * Method : delete
     * API No : 4.29
     * url : /api/v1/{cmpnNo}/service/{svcno}/extension/{extApplInstlNo}
     * **/
    deleteExtension(svcNo: string, extApplInstlNo: string) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/service/${svcNo}/extension/${extApplInstlNo}`;

        return this.http
            .delete(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * service
     * Extension 등록
     * Mothod : Post
     * API No : 4.30
     * url : /api/v1/{cmpnNo}/service/{svcno}/extension
     * **/
    addExtension(svcNo: string, postData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/service/${svcNo}/extension`;

        return this.http
            .post(url, JSON.stringify(postData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * service
     * Extension 상세
     * Mothod : Get
     * API No : 4.31
     * url : /api/v1/{cmpnNo}/service/{svcno}/extension/{extApplInstlNo}
     * **/
    getExtension(svcNo: string, extApplInstlNo: string) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/service/${svcNo}/extension/${extApplInstlNo}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * service
     * Maintenance History 상세
     * Mothod : Get
     * API No : 4.32
     * url : /api/v1/{cmpnNo}/service/{svcno}/maintenance/{mtncPlanNo}/history
     * **/
    getMtncHistory(svcNo: string, mtncPlanNo: string) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/service/${svcNo}/maintenance/${mtncPlanNo}/history?page=1&rows=1000&oidx=regDt:desc`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * service
     * service route rule 조회
     * Mothod : Get
     * API No :
     * /api/v1/{cmpnNo}/service/{serviceNo}/routrule
     **/
    getServiceRouteRule(svcNo) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/service/${svcNo}/routrule`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * service
     * service route rule 등록
     * Mothod : Post
     * API No :
     * /api/v1/{cmpnNo}/service/{serviceNo}/routrule
     * **/
    addServiceRouteRule(svcNo: string, postData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/service/${svcNo}/routrule`;

        return this.http
            .post(url, JSON.stringify(postData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * service
     * service route rule 수정
     * Mothod : Put
     * API No :
     * url : /api/v1/{cmpnNo}/service/{serviceNo}/routrule
     * **/
    modifyServiceRouteRule(svcNo: string, putData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/service/${svcNo}/routrule`;

        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * service
     * service route rule 삭제
     * Method : delete
     * API No :
     * url : /api/v1/{cmpnNo}/service/{serviceNo}/routrule/{procRuleNo}/ruleroutgrp/{ruleRoutGrpNo}
     * **/
    deleteServiceRouteRule(svcNo: string, procRuleNo: string, ruleRoutGrpNo: string) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/service/${svcNo}/routrule/${procRuleNo}/ruleroutgrp/${ruleRoutGrpNo}`;

        return this.http
            .delete(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * service
     * service route rule 우선 순위 변경
     * Mothod : Put
     * API No :
     * url : /api/v1/{cmpnNo}/service/{serviceNo}/routrule-ordr
     * **/
    modifyServiceRouteRuleOrder(svcNo: string, putData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/service/${svcNo}/routrule-ordr`;

        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * service
     * service route 메시지 스펙 조회
     * Method : Get
     * API No :
     * url : /api/v1/{cmpnNo}/service/msgspec
     * **/
    getServiceRouteMsgSpec() {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/service/msgspec`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    private handleError(error: any) {
        //console.error('An error occurred', error);
        return Promise.resolve(error.message || error);
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/services/src/api/service.services.ts